// modules
import { deepObserve } from 'mobx-utils';
import LiveDataService from 'modules/LiveData';
import FormatService from 'modules/Format';
// constants
import { Exchange } from 'modules/Search/constants';
// typings
import { MarketFeederV2 } from 'modules/LiveData/typings';
import { PositionBase } from './Positions/typings';

type TV2Callback =
  (
    exchange: Exchange,
    scripData: MarketFeederV2.IScripModeInfo<MarketFeederV2.FormattedLTPC>
  ) => void

// Listen to scrip updates and update TV row with new LTP
export function listenToLiveDataV2Changes(callback: TV2Callback) {
  deepObserve(LiveDataService.LIVE_DATA, (newValue, path, root) => {
    const exchange = path.replace(/\/.*/, '') as Exchange;

    const scrip = root[exchange];
    if (scrip) {
      const currentScripData = scrip[scrip.currentSub];

      if (currentScripData) {
        callback(exchange, currentScripData);
      }
    }
  });
}

// Method to extract order details for multi square off
export const getBasketOrderChargesRequestData = (positions: PositionBase[]) =>
  positions.map((position) => {
    const quantity = Math.abs(position.netInfo.buyQty -
      position.netInfo.sellQty);
    const side = position.netInfo.buyQty > position.netInfo.sellQty ? 'B' : 'S';
    const liveData =
      LiveDataService.getByInstrumentKey(position.instrument_key);
    const ltp = liveData?.lastTradedPrice || '0';

    return {
      instrumentKey: position.instrument_key,
      quantity,
      itemId: FormatService.generateUUID(),
      price: ltp,
      product: position.product,
      side,
    };
  });
